module.exports = __webpack_public_path__ + "img/briefcase.989d99d1.svg";